/**
 * Leitura de uma anamnese gravada (`data.anamnese` é JSON com [{ label, value,
 * observation }]) para exibição no card e no PDF.
 */

// Normaliza os tipos de resposta: lista vira texto separado por vírgula, objeto vira JSON
export function anamnesisAnswerText(text) {
  if (text === null || text === undefined) return '';
  if (Array.isArray(text)) return text.join(', ');
  if (typeof text === 'object') return JSON.stringify(text);
  return String(text).replace(/\n/g, '\n');
}

/** Itens da anamnese já com resposta e observação em texto: [{ label, answer, observation }]. */
export function parseAnamnesisAnswers(data) {
  let list = [];
  try {
    list = JSON.parse(data?.anamnese) || [];
  } catch (error) {
    list = [];
  }
  return (Array.isArray(list) ? list : []).map((item) => ({
    label: item.label,
    answer: anamnesisAnswerText(item.value).trim(),
    observation: item.observation ? anamnesisAnswerText(item.observation) : '',
  }));
}

/** Nome do modelo da anamnese (CompanyConfig.AnamneseTemplates), ou "Anamnese". */
export function anamnesisTemplateLabel(companyConfig, data) {
  const template = (companyConfig?.AnamneseTemplates || []).find((item) => String(item.Id) === String(data?.template));
  return template?.Label || 'Anamnese';
}
